import React, { useEffect } from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';

import { milestonesActions } from '~/redux/ducks/milestones';
import { REGULAR_SEASON_ID } from '~/utility/constants';

import MilestoneTable from './components/MilestoneTable';
import { MilestoneType } from './enums';
import { milestoneMessages } from './milestoneMessages';

import { MilestoneContainer, Note, Section, SectionHeader } from './styles';

const Milestone = () => {
    const dispatch = useDispatch();
    const milestones = useSelector(({ milestones }) => milestones);

    useEffect(() => {
        dispatch(milestonesActions.requestMilestones(REGULAR_SEASON_ID));
    }, []);

    if (milestones.length === 0) {
        return <LoadingDisplay isLoading />;
    }

    return (
        <MilestoneContainer>
            <Section>
                <SectionHeader>
                    <FormattedMessage {...milestoneMessages.labels.goalies} />
                </SectionHeader>
            </Section>
            <MilestoneTable milestoneType={MilestoneType.goalieGamesPlayed} milestoneData={milestones} />
            <MilestoneTable milestoneType={MilestoneType.goalieWins} milestoneData={milestones} />
            <MilestoneTable milestoneType={MilestoneType.goalieShutouts} milestoneData={milestones} />
            <MilestoneTable milestoneType={MilestoneType.goalieMinutesPlayed} milestoneData={milestones} />

            <br />
            <Section>
                <SectionHeader>
                    <FormattedMessage {...milestoneMessages.labels.skaters} />
                </SectionHeader>
            </Section>
            <MilestoneTable milestoneType={MilestoneType.skaterGamesPlayed} milestoneData={milestones} />
            <MilestoneTable milestoneType={MilestoneType.skaterGoals} milestoneData={milestones} />
            <MilestoneTable milestoneType={MilestoneType.skaterAssists} milestoneData={milestones} />
            <MilestoneTable milestoneType={MilestoneType.skaterPoints} milestoneData={milestones} />

            <Note>
                * <FormattedMessage {...milestoneMessages.labels.denotesReachedMilestone} />
            </Note>
        </MilestoneContainer>
    );
};

export { Milestone as Component };
